import updateDocument from "../../helpers/updateDocument";

import createApprovalData from "./createApprovalData";

export default async function resetDocument(ref, { user, ...data }) {
	await updateDocument(ref, {
		approval: createApprovalData(null, user),
		...data,
	});
}
